import React from 'react';
import LoadingCircle from 'components/ui/LoadingCircle';
const ADMIN = 'Admin';
const CARRIER = 'Carrier';
const SHIPPER = 'Shipper';
const ALL_USERS = [ADMIN, CARRIER, SHIPPER];
const renderValue = (value) => React.createElement("td", null, value);
const renderOnEditAction = (value, row, userType, onEditActionClick, label) => (React.createElement("td", null,
    React.createElement("button", { className: "text-green-500", onClick: () => onEditActionClick(label, row), disabled: !value }, value)));
const renderLoader = () => (React.createElement("td", null,
    React.createElement(LoadingCircle, null)));
const OFFER_PLANNER_COLUMNS = [
    {
        name: 'CUSTOMER',
        users: ALL_USERS,
        attribute: 'customer',
        show: true,
        sort: true,
        columnInfo: 'SHIPPER_NAME',
        render: (value) => {
            return React.createElement("td", null, value);
        },
    },
    {
        name: 'ORIGIN',
        attribute: 'full_origin_address',
        sort: true,
        columnInfo: 'ORIGIN_DESCRIPTION',
        render: (value) => renderValue(value),
    },
    {
        name: 'DESTINATION',
        attribute: 'full_destination_address',
        sort: true,
        columnInfo: 'DESTINATION_DESCRIPTION',
        render: (value) => renderValue(value),
    },
    {
        name: 'TYPE',
        attribute: 'type',
        sort: true,
        columnInfo: 'TYPE_DESCRIPTION',
        render: (value) => renderValue(value),
    },
    {
        name: 'CARRIERS WITH RATES',
        attribute: 'carriers_with_rates',
        columnInfo: 'CARRIERS_WITH_RATES',
        render: (value, row, userType, onEditActionClick) => row.carrier_offers
            ? renderOnEditAction(value.length, row, userType, onEditActionClick, 'carrierWithRates')
            : renderLoader(),
    },
    {
        name: 'CARRIER WITH NO RATES',
        attribute: 'carrier_with_no_rates',
        columnInfo: 'CARRIER_WITH_NO_RATES',
        render: (value, row, userType, onEditActionClick) => value && value !== 0 && row.carrier_offers
            ? renderOnEditAction(value.length, row, userType, onEditActionClick, 'carrierWithNoRates')
            : renderLoader(),
    },
    {
        name: 'CARRIER WITH OFFER',
        attribute: 'carrier_with_offer',
        columnInfo: 'CARRIER_WITH_OFFER',
        render: (value, row, userType, onEditActionClick) => value
            ? renderOnEditAction(value.length, row, userType, onEditActionClick, 'carrierWithOffer')
            : renderLoader(),
    },
    {
        name: 'LOWEST RATE',
        attribute: 'lowest_rate',
        columnInfo: 'LOWEST_RATE',
        render: (value) => renderValue(value || 'none'),
    },
    {
        name: 'HIGHEST RATE',
        attribute: 'highest_rate',
        columnInfo: 'HIGHEST_RATE',
        render: (value) => renderValue(value || 'none'),
    },
    {
        name: 'TOTAL COMMITMENT',
        attribute: 'total_commitment',
        columnInfo: 'TOTAL_COMMITMENT',
        render: (value, row, userType, onEditActionClick) => renderOnEditAction(value, row.carrierRates, userType, onEditActionClick, 'totalCommitment'),
    },
    {
        name: 'COMMITMENT OFFERED',
        attribute: 'commitment_dispatched',
        columnInfo: 'COMMITMENT_DISPATCHED',
        render: (value, row, userType, onEditActionClick) => value && row.commitment_dispatched
            ? renderOnEditAction(value.length, row, userType, onEditActionClick, 'commitmentDispatched')
            : renderLoader(),
    },
    {
        name: 'CONTAINERS AVAILABLE',
        attribute: 'containers_available',
        columnInfo: 'CONTAINERS_AVAILABLE',
        render: (value, row, userType, onEditActionClick) => renderOnEditAction(value.length, row, userType, onEditActionClick, 'containersAvailable'),
    },
    {
        name: 'CONTAINERS DISPATCHED',
        attribute: 'containers_dispatched',
        columnInfo: 'CONTAINERS_DISPATCHED',
        render: (value, row, userType, onEditActionClick) => renderOnEditAction(value.length, row, userType, onEditActionClick, 'containersDispatched'),
    },
    {
        name: 'PAST LFD',
        attribute: 'past_lfd',
        columnInfo: 'PAST_LFD',
        render: (value, row, userType, onEditActionClick) => renderOnEditAction(value.length, row, userType, onEditActionClick, 'pastLfd'),
    },
    {
        name: 'LFD TODAY',
        attribute: 'lfd_today',
        columnInfo: 'LFD_TODAY',
        render: (value, row, userType, onEditActionClick) => renderOnEditAction(value.length, row, userType, onEditActionClick, 'todayLfd'),
    },
    {
        name: 'LFD TOMORROW',
        attribute: 'lfd_tomorrow',
        columnInfo: 'LFD_TOMORROW',
        render: (value, row, userType, onEditActionClick) => renderOnEditAction(value.length, row, userType, onEditActionClick, 'tomorrowLfd'),
    },
    {
        name: 'LFD 2DAYS',
        attribute: 'lfd_2days',
        columnInfo: 'LFD_2DAYS',
        render: (value, row, userType, onEditActionClick) => renderOnEditAction(value.length, row, userType, onEditActionClick, 'twoDayLfd'),
    },
    {
        name: 'LFD UNKNOWN',
        attribute: 'lfd_unknown',
        columnInfo: 'LFD_UNKNOWN',
        render: (value, row, userType, onEditActionClick) => renderOnEditAction(value.length, row, userType, onEditActionClick, 'unknownLfd'),
    },
    {
        name: 'CONTAINERS NOT AVAILABLE',
        attribute: 'containers_not_available',
        columnInfo: 'CONTAINERS_NOT_AVAILABLE',
        render: (value, row, userType, onEditActionClick) => renderOnEditAction(value.length, row, userType, onEditActionClick, 'containersNotAvailable'),
    },
];
export default OFFER_PLANNER_COLUMNS.map((column) => (Object.assign(Object.assign({}, column), { users: ALL_USERS, show: true })));
